import { useState, useEffect, useReducer, useContext } from "react";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const whatsApps = action.payload;
    // Filtrar valores null/undefined e garantir que todos tenham id
    const validWhatsApps = Array.isArray(whatsApps) 
      ? whatsApps.filter(w => w && w.id != null)
      : [];
    return [...validWhatsApps];
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const whatsApp = action.payload;
    // Validar se whatsApp e id existem
    if (!whatsApp || whatsApp.id == null) {
      console.warn("UPDATE_WHATSAPPS: payload inválido", whatsApp);
      return [...state];
    }
    
    // Filtrar nulls do state antes de buscar
    const cleanState = state.filter(s => s && s.id != null);
    const whatsAppIndex = cleanState.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      cleanState[whatsAppIndex] = whatsApp;
      return [...cleanState];
    } else {
      return [whatsApp, ...cleanState];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const whatsApp = action.payload;
    // Validar se whatsApp e id existem
    if (!whatsApp || whatsApp.id == null) {
      console.warn("UPDATE_SESSION: payload inválido", whatsApp);
      return [...state];
    }
    
    // Filtrar nulls do state antes de buscar
    const cleanState = state.filter(s => s && s.id != null);
    const whatsAppIndex = cleanState.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      cleanState[whatsAppIndex].status = whatsApp.status;
      cleanState[whatsAppIndex].updatedAt = whatsApp.updatedAt;
      cleanState[whatsAppIndex].qrcode = whatsApp.qrcode;
      cleanState[whatsAppIndex].retries = whatsApp.retries;
      return [...cleanState];
    } else {
      return [...cleanState];
    }
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const whatsAppId = action.payload;
    // Validar se whatsAppId existe
    if (whatsAppId == null) {
      console.warn("DELETE_WHATSAPPS: payload inválido", whatsAppId);
      return [...state];
    }
    
    // Filtrar nulls do state antes de buscar
    const cleanState = state.filter(s => s && s.id != null);
    const whatsAppIndex = cleanState.findIndex((s) => s.id === whatsAppId);
    if (whatsAppIndex !== -1) {
      cleanState.splice(whatsAppIndex, 1);
    }
    return [...cleanState];
  }

  if (action.type === "RESET") {
    return [];
  }
  
  // Retornar state atual se action type não for reconhecido
  return state;
};

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(true);
  const { user, socket, isAuth, loading: authLoading } = useContext(AuthContext);

  // Effect para carregar os dados iniciais
  useEffect(() => {
    if (authLoading) {
      return;
    }

    if (!isAuth || !user?.id || !localStorage.getItem("token")) {
      dispatch({ type: "RESET" });
      setLoading(false);
      return;
    }

    setLoading(true);
    const fetchSession = async () => {
      try {
        const { data } = await api.get("/whatsapp/?session=0");
        dispatch({ type: "LOAD_WHATSAPPS", payload: data });
        setLoading(false);
      } catch (err) {
        console.error("Erro ao carregar WhatsApps:", err);
        setLoading(false);
      }
    };
    fetchSession();
  }, [authLoading, isAuth, user?.id]);

  // Effect para configurar os listeners do socket
  useEffect(() => {
    if (user?.companyId && socket && typeof socket.on === 'function' && typeof socket.off === 'function') {
      const companyId = user.companyId;
      
      const onCompanyWhatsapp = (data) => {
        if (data.action === "update") {
          dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
        }
        if (data.action === "delete") {
          dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
        }
      };

      const onCompanyWhatsappSession = (data) => {
        if (data.action === "update") {
          dispatch({ type: "UPDATE_SESSION", payload: data.session });
        }
      };

      const whatsappEvent = `company-${companyId}-whatsapp`;
      const sessionEvent = `company-${companyId}-whatsappSession`;

      socket.on(whatsappEvent, onCompanyWhatsapp);
      socket.on(sessionEvent, onCompanyWhatsappSession);

      return () => {
        if (socket && typeof socket.off === 'function') {
          socket.off(whatsappEvent, onCompanyWhatsapp);
          socket.off(sessionEvent, onCompanyWhatsappSession);
        }
      };
    }
  }, [socket, user?.companyId]);

  return { whatsApps, loading };
};

export default useWhatsApps;
